import React from 'react';
import { Resource } from 'react-admin';
import { Route } from 'react-router-dom';

import { CompanySettingsPage } from '../../pages/settings/';
import Messages from '../../resources/messages/List/List';
import {
	OrderEditByTransporter,
	OrderShowTabsWrapper,
	commonOrdersResourceData,
	ordersResource
} from '../../resources/orders/';

export const transporterEmployeeResources = [
	<Resource name="orders" list={ordersResource.list} edit={OrderEditByTransporter} show={OrderShowTabsWrapper}/>,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource name="ports" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist" intent="registration" />,
	<Resource name="trucks" intent="registration" />,
	<Resource name="trailers" intent="registration" />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="external-terminal" intent="registration" />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="terminal"/>,

	// <Resource name="drivers" {...customerDriversResource} />,
];

export const transporterEmployeeRoutes = [
	<Route exact path="/messages" component={Messages} />,
];
